// extracted by mini-css-extract-plugin
module.exports = {"h100":"FuturesTradesTable_h100_38rRw","w100":"FuturesTradesTable_w100_FoUZG"};